<template>
  <div>
    <div @click="show = true">
      <slot />
    </div>

    <StakeModal v-model="show">
      <div class="tw-flex tw-flex-col tw-gap-5 tw-p-5">
        <h2 class="tw-text-lg tw-font-bold tw-text-gray-700 tw-mb-5">
          Link a YourStake Prospect or Client to this meeting
          <div class="tw-text-sm tw-font-normal tw-text-gray-500">
            Then you will be able to link the Prospect or Client to your CRM on the Pre-Meeting Prep tab of your meeting
          </div>
        </h2>

        <MeetingGlance :meeting="meeting" />

        <EntitySelect
          :current="meeting.entity"
          @select="handleSelect"
          :disabled="isLoading"
        />

        <div v-if="isLoading" class="tw-flex tw-justify-center">
          <i class="fa fa-spinner fa-spin" />
        </div>
      </div>
    </StakeModal>
  </div>
</template>


<script>
import StakeModal from '@stakeui/StakeModal.vue';
import EntitySelect from '@frontend/ui/components/utils/EntitySelect.vue';
import MeetingGlance from '@frontend/ui/features/meetings/components/MeetingGlance.vue';


export default {
  name: 'LinkEntityToMeeting',
  components: {
    StakeModal,
    EntitySelect,
    MeetingGlance,
  },
  props: {
    // Inputs
    meeting: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Local variables
      show: false,
      isLoading: false,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    headers() {
      return {
        'X-CSRFToken': this.$root.$data.csrfToken,
        'Content-Type': 'application/json',
      };
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    handleSelect(entity) {
      console.log('Entity selected:', entity);
      this.linkToMeeting(entity);
    },
    async linkToMeeting(entity) {
      this.isLoading = true;
      try {
        const res = await fetch(`/api/v1/meetings/${this.meeting.id}/entity/`, {
          method: 'POST',
          headers: this.headers,
          body: JSON.stringify({
            entity_external_id: entity.external_id,
          }),
        });

        if (res.ok) {
          this.$emit('updated', {
            ...this.meeting,
            entity,
          });
        }
      } finally {
        this.isLoading = false;
        this.show = false;
      }
    },
  },
};
</script>


<style scoped>

</style>
